<template>
  <div class="notifyTab">

    <div class="c-common-space jobs-gridview c-responsive-fixwidth o-overflow-visible">
                <div class="row">
                    <!-- single grid -->
                    <div class="col-sm-12 col-md-12">
                        <div class="grids c-common-box-shadow c-radius3 c-bg-white o-super-signin-area">

                            <div class="head">
                                <h3 class="o-super-title">Notify Settings:</h3>
                            </div>

                            <div class="body">
                                 <div class="row">
                                    <div class="col-sm-12">

                                        <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                           <h6 class="bold-text"><strong>For Email</strong></h6>
                                            <p class="ps1 extra-small-text">* this the default email id from where email will be send</p>
                                        </div>
                                        <div class="col-sm-4 o-no-padding">
                                            <div class="col-sm-12 o-left-no-padding">
                                                <input type="email" v-model="defaultSendIds.email" placeholder="Type Email Id" name="" class="form-control">
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <hr class="o-modal-separetor" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">

                                        <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                           <h6 class="bold-text"><strong>For SMS</strong></h6>
                                            <p class="ps1 extra-small-text">* this the default number from where all SMS will be send</p>
                                        </div>
                                        <div class="col-sm-4 o-no-padding">
                                            <div class="col-sm-4 o-left-no-padding">
                                                <select name="countryCode" v-model="defaultSendIds.countryCode" class="form-control">
                                                    <!-- <option data-countryCode="GB" value="44" Selected>UK (+44)</option> -->
                                                    <option data-countryCode="US" value="1">USA (+1)</option>
                                                    <option data-countryCode="CA" value="1">Canada (+1)</option>
                                                    <!-- <option data-countryCode="IN" value="91">India (+91)</option> -->
                                                </select>
                                            </div>
                                            <div class="col-sm-8 o-left-no-padding">
                                                <input type="number" v-model="defaultSendIds.sms" placeholder="Type Phone Number" name="" class="form-control">
                                            </div>
                                        </div>

                                    </div>
                                </div>
                   
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="o-common-margin-top20">
                                            <ul class="o-filter-area o-margin-bottom10">
                                                <li>
                                                    <a href="javascript: void(0)" @click="backToList()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                                </li>
                                                <li>
                                                    <a href="javascript: void(0)" @click="saveSettingsData()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                    <!-- /single grid -->
                </div>

            </div>

  </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';

    export default {
        data() {
            return {
                defaultSendIds:{
                    email:'',
                    sms:'',
                    countryCode:'1',
                },

            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                selectedClientId: 'selectedClientId',
                userRole: 'userRole',
            })
        },
        methods: {
            backToList() {
                this.$router.push({
                    'path': '/clientList'
                });
            },
            saveSettingsData(){
                //console.log(this.defaultSendIds);
                service.post('client/'+this.selectedClientId+'/notificationSettings', {'element': this.defaultSendIds}, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId' : this.selectedClientId
                }).then((res) => {
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Default Send Ids Updated Successfully.',
                        type: 'success'
                    });
                }).catch((err) => {
                    console.log(err);
                });
            }          

        },
        created() { 
             //console.log(this.selectedClientId);
             service.get('client/' + this.selectedClientId, {
                    'Authorization': this.userToken
            })
            .then((res) => {
                var temp ={
                    email:'',
                    sms:'',
                    countryCode:'1',
                }
                this.defaultSendIds = (res.data.result.settings['notification-config'] && res.data.result.settings['notification-config'].length!=0)? res.data.result.settings['notification-config'] : temp;
                //console.log(res.data.result);
            }).catch((err) => {
                console.log(err);
            });
        }
    }

</script>
